import { combineReducers } from 'redux';
import allEquipmentForSites from './allEquipmentForSites';
import app from './app';
import dialog from './dialog';
import equipmentFilter from './equipmentFilter';
import equipmentGrouping from './equipmentGrouping';
import equipmentTags from './equipmentTags';
import equipment from './equipment';
import loading from './loading';
import pageInfo from './pageInfo';
import sites from './sites';
import siteOnlineStatusById from './siteOnlineStatusById';
import siteFilter from './siteFilter';
import spaces from './spaces';
import sensors from './sensors';
import sentinels from './sentinels';
import notifications from './notifications';
import notificationsCount from './notificationsCount';
import notificationFilter from './notificationFilter';
import resources from './resources';
import equipmentBySiteId from './equipmentBySiteId';
import spacesBySiteId from './spacesBySiteId';
import gatewaysBySiteId from './gatewaysBySiteId';
import sensorsBySiteId from './sensorsBySiteId';
import coolerRecommendationsBySiteId from './coolerRecommendationsBySiteId';
import humidityRecommendationsBySiteId from './humidityRecommendationsBySiteId';
import energyRecommendationsBySiteId from './energyRecommendationsBySiteId';
import energy from './energy';
import filteredNotifications from './filteredNotifications';
import organizations from './organizations';
import operationalSamples from './samples';
import { Actions } from '../actions/app';

const appReducer = combineReducers({
  app,
  dialog,
  equipment,
  equipmentFilter,
  equipmentGrouping,
  equipmentTags,
  loading,
  notifications,
  notificationsCount,
  notificationFilter,
  pageInfo,
  sites,
  siteOnlineStatusById,
  siteFilter,
  spaces,
  sensors,
  sentinels,
  energy,
  resources,
  equipmentBySiteId,
  spacesBySiteId,
  gatewaysBySiteId,
  sensorsBySiteId,
  coolerRecommendationsBySiteId,
  humidityRecommendationsBySiteId,
  energyRecommendationsBySiteId,
  allEquipmentForSites,
  filteredNotifications,
  organizations,
  operationalSamples,
});

const rootReducer = (state, action) => {
  if (action.type === Actions.LOGOUT) {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default rootReducer;
